import {
    AT_BOARD_USER_META_ACTION_SET,
    IBoardUserMetaActionSetAction
} from 'app/store/model/boardUserMetas/actions/types';
import { TBoardUserMetaAction } from 'app/store/model/boardUserMeta/actions/types';

export const boardUserMetasActionSet = (
    boardId: number,
    boardUserMetaAction: TBoardUserMetaAction
): IBoardUserMetaActionSetAction => {
    return {
        type: AT_BOARD_USER_META_ACTION_SET,
        boardId,
        boardUserMetaAction
    };
};
